import React from 'react';
import { Icon } from 'semantic-ui-react';

export default ({ message }) => (
  <p>
    <Icon name="exclamation triangle" color="orange" /> {message}
  </p>
);
